"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _apolloClient = require("@/apollo/apolloClient");

var _userQuery = require("@/apollo/queries/user-query");

var _firebase = require("firebase");

var realTimeStore = {
  getters: {
    // gettersには メソッドを記述
    getMyAvatar: function getMyAvatar(state) {
      return state.myAvatar;
    }
  },
  state: {
    myAvatar: ''
  },
  mutations: {
    MY_AVATAR_CREATE: function MY_AVATAR_CREATE(state, value) {
      state.myAvatar = value;
    }
  },
  actions: {
    getMyAvatarAction: function () {
      var _getMyAvatarAction = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref) {
        var commit, state, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, state = _ref.state;
                _context.next = 3;
                return _apolloClient.apolloClient.query({
                  query: _userQuery.MY_AVATAR,
                  variables: {
                    my_uid: (0, _firebase.auth)().currentUser.uid
                  }
                });

              case 3:
                res = _context.sent;

                if (!res.errors) {
                  _context.next = 6;
                  break;
                }

                throw res.errors[0].message;

              case 6:
                commit('MY_AVATAR_CREATE', res.data.user.avatar);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getMyAvatarAction(_x) {
        return _getMyAvatarAction.apply(this, arguments);
      }

      return getMyAvatarAction;
    }()
  }
};
var _default = realTimeStore;
exports.default = _default;